export default __webpack_public_path__ + "static/media/close-59.91537f61.svg";